import { ICodeInputPropsInterface } from "interfaces";
import { useEffect, useState, useRef, ChangeEvent, KeyboardEvent } from "react";

let currentOtpIndex = 0;

const CodeInput = ({ onChange }: ICodeInputPropsInterface) => {

    const [otp, setOtp] = useState<string[]>(new Array(6).fill(""));
    const [activeOtpIndex, setActiveOtpIndex] = useState<number>(0);
    const inputRef = useRef<HTMLInputElement>(null);
    const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
        const { value } = e.target;
        const newOtp = [...otp];
        newOtp[currentOtpIndex] = value.substring(value.length - 1);
        if (!value) setActiveOtpIndex(currentOtpIndex - 1);
        else setActiveOtpIndex(activeOtpIndex + 1);
        setOtp(newOtp);
        onChange(newOtp.join(""));
    }

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>, index: number) => {
        currentOtpIndex = index
        if (event.key === "Backspace") setActiveOtpIndex(currentOtpIndex - 1);
    }

    useEffect(() => {
        inputRef.current?.focus();
    }, [activeOtpIndex])

    return (
        <div className="pl-flex pl-justify-center pl-items-center pl-gap-2 pl-mt-6" dir="ltr">
            {otp.map((item: string, index: number) => {
                return (
                    <input
                        key={index}
                        ref={index === activeOtpIndex ? inputRef : null}
                        type="number"
                        className={`pl-w-12 pl-h-7 pl-border-b pl-bg-transparent pl-outline-none pl-text-center pl-font-medium pl-text-[18px] pl-border-z-gray-400 dark:pl-border-dark-5 focus:pl-border-main-light focus:pl-text-gray-700 pl-text-black dark:pl-text-z-secondary-50 pl-transition"}`}
                        onKeyDown={(event) => handleKeyDown(event, index)}
                        onChange={handleChange}
                        value={otp[index]}
                    />
                );
            })}
        </div>
    )
}

export default CodeInput;